import * as React from "react";
const SvgFiRrCarBump = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-bump_svg__a)">
      <path
        fill="#062147"
        d="M23.23 23.973a1 1 0 0 1-1.2-.744c-.7-2.946-5.317-2.915-6.058.016a1 1 0 1 1-1.94-.49c1.231-4.947 8.773-4.935 9.943.016a1 1 0 0 1-.746 1.202M8.853 19.251a2 2 0 0 1-3.707 1.5l-.076-.185a4.01 4.01 0 0 1-4.027-2.483l-.529-1.3A9.9 9.9 0 0 1 0 13.385s.121-5.242.125-5.279A5.01 5.01 0 0 1 3.2 4.138l7.108-2.775a5 5 0 0 1 4.958.7l3.818 3.476A7.3 7.3 0 0 1 21.175 8.5l.53 1.3a4.02 4.02 0 0 1-.973 4.429l.07.168a2 2 0 0 1-3.682 1.563zM2.115 8.321 2 13.383 17.8 7.07l-3.826-3.477a2.99 2.99 0 0 0-2.927-.372L3.94 6a3 3 0 0 0-1.824 2.321M5.5 18.432l13.255-5.272a2 2 0 0 0 1.1-2.6l-.529-1.3a7 7 0 0 0-.247-.54l-1.834.733.381.937a1 1 0 1 1-1.853.753l-.385-.948-9.522 3.797.363.915a1 1 0 0 1-1.858.738l-.362-.911-1.809.724q.063.292.172.57l.53 1.3A2 2 0 0 0 5.5 18.432"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-bump_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarBump;
